import { ELYSIUM, isElysiumFreePolicy, sameIdentity } from "../../../config/elysium";
import type { ReferralMilestone } from "../api/referral-schemas";

// ElysiumRewardNft._freeMintRewardSpan and src/referral/referral-rewards.ts,
// pulled source SHA-256 3efadd4f02edba0c51f7a72ba740a2795310756bf530d96a4139801aa2dc5c73.
const legacy = { 50: [10, 50], 100: [50, 100], 500: [100, 300] } as const;
const social = { 50: [5, 10], 100: [10, 25], 500: [25, 75] } as const;
export function referralRewardRange(milestone: ReferralMilestone, policyVersion: string | bigint,
  policyHash: string, chainId: number): { min: number; max: number } | null {
  if (String(policyVersion) !== "1" || chainId === ELYSIUM.chainId && !isElysiumFreePolicy(policyVersion, policyHash)) return null;
  const [min, max] = (sameIdentity(policyHash, ELYSIUM.socialRewardPolicyHash) ? social : legacy)[milestone];
  return { min, max };
}
export function currentReferralRange(milestone: ReferralMilestone, chainId: number) {
  const [min, max] = (chainId === ELYSIUM.chainId ? social : legacy)[milestone];
  return { min, max };
}
